module.exports = __webpack_public_path__ + "img/Filter.de337b6f.png";